SppHandler = App.loadClass 'grower::handlers/placement/SppHandler'

class exports.BurrusSPPHandler extends SppHandler

    init: () ->

        # note that @ is the SPP Handler, not the Step Handler
        @customStepFunctions =

            step_3:
                afterEnter: @stepFunctions.addMaturityValidation

        @hybridButtonContents =
            title: 'seed_company_name'
            table:
                'Brand': 'display_name'
                'Trait': 'trait_summary'
                'RM': 'relative_maturity'

        @customButtons = [
            {
                'html': '<button class="btn btn-blue" id="pdf_button" data-loading-text="Generating report...">
                        <i class="fa fa-file-o"></i> Placement Summary Report
                    </button>'
                'click': () =>
                    layers = @curStep.stepKO.plantingPlans()
                    @actionPdf(layers, false, '#long_pdf_button')
            },
            {
                'html': '<br /> <button class="btn btn-blue" style="margin-top: 10px;" id="long_pdf_button" data-loading-text="Generating report...">
                        <i class="fa fa-file-o"></i> Placement Summary Detail Report
                    </button>'
                'click': () =>
                    layers = @curStep.stepKO.plantingPlans()
                    @actionPdf(layers, true, '#long_pdf_button')
            },
        ]

        # LEVEL UP!
        super()

    # This function will be passed into the Planting dialog controller via
    # PlantingOptions. "plan" is the Layer model used for the Plan tab.
    # "notes_obj" is the object used by the Notes tab.
    customPlantingPlan: (field_id, plan, notes_obj) =>
        products = @taffyObjects.hybrids

        nematode = @getFieldAspectByName(field_id, 'Nematode')?.value

        @_customProductSubscription = (stage, product_id) ->
            product = products(id: parseInt(product_id)).first()

            t1 = product?.default_treatment_id
            t2 = product?.secondary_treatment_id
            if nematode
                stage.treatment = t2 ? t1
            else
                stage.treatment = t1

            notesFn()

        static_notes = 'If planting conditions aren\'t ideal, you may need to increase the population<br/>'

        # debugAlert(rw_option)

        notesFn = () ->
            product_id = plan.events[0]?.stages[0]?.product?.id
            product = products(id: parseInt(product_id)).first()

            notes = ''
            if product?.description
                notes += product.description + '<br/>'

            notes_obj.notes = notes + static_notes
